import type { Capability, Scope } from '@cop/shared';
import type { Principal } from './types';

/**
 * Capability checks drive what the UI shows. They are a convenience only — the API
 * enforces every permission; hiding a control is never a security boundary.
 */
export function can(principal: Principal | null | undefined, cap: Capability): boolean {
  return !!principal?.capabilities?.[cap];
}

export function scopeOf(principal: Principal | null | undefined, cap: Capability): Scope | null {
  return principal?.capabilities?.[cap] ?? null;
}

export function canAny(principal: Principal | null | undefined, caps: Capability[]): boolean {
  return caps.some((c) => can(principal, c));
}
